/** @file Matches an own commit to the first sent, unanswered batch with equal command names (E8-R3). */
import type { CommitSummary } from '@pose2d/api/types';
import type { PendingBatch } from '../../stores/liveStore';

const names = (list: readonly { name: string }[]): string => list.map((c) => c.name).join('\n');

/** The batches with the first sent, unmatched batch whose command names equal the commit's marked as `summary.rev`;
 *  unchanged when the REST answer already named the batch of that rev (its frame came after the answer). */
export function markOwnCommit(batches: readonly PendingBatch[], summary: CommitSummary): PendingBatch[] {
  if (batches.some((b) => b.committedRev === summary.rev)) return [...batches];
  const wanted = names(summary.commands);
  const at = batches.findIndex((b) => b.sent && b.committedRev === null && names(b.pending) === wanted);
  return batches.map((b, i) => (i === at ? { ...b, committedRev: summary.rev } : b));
}
